


















































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Input from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import ModulesHelper from '@core/services/modules.helper';
import DatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';

@Component({
  name: 'bc-booking-renew-modal',
  components: {
    'bpc-input': Input,
    'bpc-entity-select': EntitySelect,
    'bpc-switch': Switch,
    'bpc-date-picker': DatePicker,
  },
})
export default class BookingRenewModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Array, default: () => [] }) readonly selectedItemIds: number[];

  public selectedPeriode = null;
  public renewingBookingEvents: boolean = false;
  public isProcessing: boolean = false;
  public withContract: boolean = false;
  public toExistingContract: boolean = false;
  public templateId: number = null;
  public startDate: string = null;
  public endDate: string = null;
  public eventsSuccess = [];
  public eventsError = [];
  public renewedBookingEventCount: number = null;

  // LIFECYCLE
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // METHODS
  closeModal() {
    this.resetModal();
    this.$emit('close-renew-modal');
  }

  finishRenew() {
    this.$emit('finish-renew');
  }

  resetModal() {
    this.selectedPeriode = null;
    this.renewingBookingEvents = false;
    this.isProcessing = false;
    this.withContract = false;
    this.toExistingContract = false;
    this.templateId = null;
    this.renewedBookingEventCount = null;
    this.startDate = null;
    this.endDate = null;
  }

  openModal() {
    this.$bvModal.show('renew-modal');
  }

  //To DO
  onConfirmRenewBooking() {
    this.renewingBookingEvents = true;
    this.isProcessing = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('booking');
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketbookingsRenewed(sessionCode);

    const payload: AnyEntity = {
      ids: this.selectedItemIds,
      period_id: this.selectedPeriode ? this.selectedPeriode.id : null,
      start_date: this.startDate,
      end_date: this.endDate,
      with_contract: this.withContract,
      to_existing_contract: this.toExistingContract,
      template_id: this.templateId,
      session_code: sessionCode,
      center_id: this.tenantId,
    };

    this.$bpcApi.post(basePath + '/renew-bookings', payload).subscribe(
      res => {
        this.renewingBookingEvents = true;
      },
      error => {
        this.renewingBookingEvents = false;
        this.isProcessing = false;
        const message = error?.response?.data?.message;
        this.$bpcMessage.showErrorMessage({ text: message });
      },
    );
  }

  listenToWebsocketbookingsRenewed(sessionCode) {
    this.$bpcEcho
      .getRenewBookingsChannel(sessionCode)
      .listen('.BPC\\Bookings\\Events\\BookingsRenewed', data => {
        this.renewingBookingEvents = false;
        this.renewedBookingEventCount = data.numberOfRenewedContract;
        this.$bpcEcho.leaveRenewBookingsChannel(sessionCode);
        this.finishRenew();
      })
      .listen('.BPC\\Bookings\\Events\\GlobalErrorRenewingBookings', data => {
        console.log(data.msg);
        this.$bpcMessage.showErrorMessage({
          text: 'bookings.renew_booking.global_error',
        });
        this.renewingBookingEvents = false;
        this.$bpcEcho.leaveRenewBookingsChannel(sessionCode);
      });
    this.isProcessing = false;
  }

  getSessionCode() {
    return `renew-booking-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      //this.resetModal();
      this.openModal();
    } else {
      this.$bvModal.hide('renew-modal');
    }
  }

  @Watch('selectedPeriode')
  onSelectedPeriodIdChange(val) {
    if (val) {
      this.startDate = val.start_date;
      this.endDate = val.end_date;
    }
  }

  isContractModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME);
  }
}
